/** @jsxImportSource @emotion/react */
import { memo, useEffect } from "react";

// 画像プレビュー表示コンポーネント
import { css } from "@emotion/react";
import Image from "components/parts/image/imageUpload/Image";
import { useRef } from "react";

const imagePreview = memo(({ src1, src2, src3, onDelete }) => {
  // 関数呼び出し用のRefを定義
  const imgRef1 = useRef(null);
  const imgRef2 = useRef(null);
  const imgRef3 = useRef(null);

  // ファイル変更時に実行
  useEffect(() => {
    if (imgRef1.current && imgRef2.current && imgRef3.current) {
      imgRef1.current.resize();
      imgRef2.current.resize();
      imgRef3.current.resize();
    }
  }, [src1, src2, src3]);

  return (
    <div css={mtgImagePreviewWrapper}>
      <div css={mtgImageWrapper}>
        <Image ref={imgRef1} src={src1} onDelete={() => onDelete(0)} />
      </div>
      <div css={mtgImageWrapper}>
        <Image ref={imgRef2} src={src2} onDelete={() => onDelete(1)} />
      </div>
      <div css={mtgImageWrapper}>
        <Image ref={imgRef3} src={src3} onDelete={() => onDelete(2)} />
      </div>
      <div css={clearFloat}></div>
    </div>
  );
});

const mtgImagePreviewWrapper = css`
  width: 100%;
`;

const mtgImageWrapper = css`
  width: 30%;
  margin: 0 1.66666%;
  float: left;
`;

const clearFloat = css`
  float: none;
  clear: both;
`;

export default imagePreview;
